<cache-date></cache-date>

<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>

<hr/>

Исходные данные
<a target="_blank" rel="noreferrer" href="https://metrika.yandex.ru/stat/sources_direct_clicks?metric=ym%3Aad%3A%3Ccurrency%3EAdCost&sort=-ym%3Aad%3A%3Ccurrency%3EAdCost&period=2018-11-01%3A2018-11-30&direct_client_logins=Ukitrus&id=27409619&stateHash=5c937fee57eb9c5b70cd2624">яндекс</a>
и
<a target="_blank" rel="noreferrer" href="https://analytics.google.com/analytics/web/#/report/advertising-adwords-campaigns/a57440954w91159525p129349660/">гугл</a>

<hr/>

<style>
	thead th {
		position: -webkit-sticky; 
		position: sticky; 
	}
	thead tr.level1 th {
		top: 1px;
	}
	thead tr.level2 th {
		top: 51px;
	}
</style>

<div class="row">
	<div class="col-md-12">
		<div class="alert alert-warning" role="alert"> Показываются только пользователи, имеющие источник регистрации "Yandex Direct" или "Google Adwords"	</div>
	</div>
</div>


<div class="row">
	<div class="col-md-12">
		<loading [isLoad]="isLoad"></loading>
		
		<table class="table table-bordered" [sextant]="'table'">
			<thead>
				<tr class="table-primary level1">
					<th rowspan="2" style="min-width: 407px;">Группа</th>
					<th colspan="2">Регистраций</th>
					<th colspan="2">Первые оплаты</th>
					<th rowspan="2">Лид принес $</th>
					<th rowspan="2">Заработали $</th>
					<th rowspan="2">Потратили $</th>
				</tr>
				<tr class="table-primary level2">
					<th>Кол-во</th>
					<th>Стоимость $</th>
					<th>Кол-во</th>
					<th>Стоимость $</th>
				</tr>
			</thead>
			
			
			<tbody>
				<tr	*ngFor="let stat of stats; let i = index">
					<td>
						<div [ngClass]="getRefererStyle(stat)">
							<button
								type="button"
								class="btn btn-link"
								(click)="showSource(stat, i)"
								*ngIf="stat.level !== 'campaign'">
								{{ stat.joinId }}
								<sup *ngIf="stat.joinId.indexOf('Google Adwords') !== -1" ngbTooltip="Есть подозрение что данные компаний искажены, из-за того, что данные получены через Analytics, а не напрямую">&#10059;</sup>
							</button>
							
							<ng-template [ngIf]="stat.level === 'campaign'">
								{{ stat.joinId }}
							</ng-template>
						</div>
						
						
						<loading [isLoad]="stat.isLoad"></loading>
					</td>
					
					<td>
						{{ stat.regCount | prettyNumber }}
					</td>
					
					<td>
						{{ stat.regCost | prettyNumber }}
					</td>
					
					<td>
						{{ stat.firstManualCount | prettyNumber }}
					</td>
					
					<td>
						{{ stat.leadCost | prettyNumber }}
					</td>
					
					<td>
						{{ stat.leadAmount | prettyNumber }}
					</td>
					
					<td>
						{{ stat.usdAmount | prettyNumber  }}
					</td>
					
					<td>
						{{ stat.usdCost | prettyNumber  }}
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>

